<template>
  <div class="update-pwd-container">
    <div class="update-pwd-card">
        <div class="card-header">
        <el-button type="text" @click="goBack" class="back-btn">
          <i class="el-icon-arrow-left"></i> 返回
        </el-button>
        <div class="title">修改密码</div>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
        <el-form-item label="验证码" prop="verification_code" label-width="90px">
          <el-input v-model="ruleForm.verification_code" placeholder="请输入验证码">
            <template #append>
              <el-button :disabled="countdown > 0" @click="getVerificationCode" style="padding: 0 10px;">
                {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password" label-width="90px">
          <el-input v-model="ruleForm.new_password" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="reNewPwd" label-width="90px">
          <el-input v-model="ruleForm.reNewPwd" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item class="submit-btn-container">
          <el-button type="primary" @click="submitForm('ruleForm')" class="submit-btn">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.new_password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          verification_code: '',
          new_password: '',
          reNewPwd: '',
        },
        rules: {
          verification_code: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }],
          new_password: [{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }, {
            min: 6,
            max: 20,
            message: '密码长度应在6-20个字符之间',
            trigger: 'blur'
          }],
          reNewPwd: [{
            required: true,
            validator: validatePass2,
            trigger: 'blur'
          }],
        },
        countdown: 0,
        timer: null
      }
    },
    created() {},
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    methods: {
            goBack() {
        this.$router.back();
      },
      getVerificationCode() {
        if (this.countdown > 0) return;
        this.$get(this.$api.send_code_by_shop_admin, {}).then(res => {
          if (res.status == 200) {
            this.$message({ message: '验证码发送成功', type: 'success' });
            this.startCountdown();
          } else {
            this.$message({ message: res.msg || '验证码发送失败', type: 'error' });
          }
        }).catch(() => {
          this.$message({ message: '网络错误', type: 'error' });
        });
      },
      startCountdown() {
        this.countdown = 60;
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(this.timer);
          }
        }, 1000);
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$post(this.$api.pwdUpdate, {
              code: this.ruleForm.verification_code,
              new_password: this.ruleForm.new_password
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: res.msg,
                  type: 'success'
                });
                this.$refs[formName].resetFields();
                if (this.timer) {
                  clearInterval(this.timer);
                  this.countdown = 0;
                }
              } else {
                this.$message({
                  message: res.msg || '修改密码失败',
                  type: 'error'
                });
              }
            }).catch(() => {
              this.$message({
                message: '网络错误',
                type: 'error'
              });
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
  }
</script>

<style scoped>
  .update-pwd-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    padding: 20px;
  }
  
  .update-pwd-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 30px;
    width: 100%;
    max-width: 400px;
  }
   .card-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-bottom: 20px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 25px;
  }
  
  .back-btn {
    position: absolute;
    left: 0;
    color: #606266;
  }
  .title {
    font-size: 18px;
    color: #303133;
    font-weight: 600;
  }
  
  .demo-ruleForm {
    width: 100%;
  }
  
  .el-form-item {
    margin-bottom: 20px;
  }
  
  .get-code-btn {
    width: 100%;
  }
  
  .submit-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  
  .submit-btn {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }
  
  .el-input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/updatePwd/index.vue